module.exports = "/../../dist/frontend/images/404-small.jpg?f8bfbaef069f1f1cd0547eb8c590a582";